// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--13jq-","tag":"_93444fe79c--tag--29UkS"};